import { AddCreditCard as ingenicoAddCreditCard } from './ingenico'
import { AddCreditCard as sixcardsAddCreditCard } from './sixcards'
import { AddCreditCard as monerisAddCreditCard } from './moneris'
import { AddCreditCard as pagseguroAddCreditCard } from './pagseguro'
import { AddCreditCard as nuveiAddCreditCard } from './nuvei'

const addCreditCardComponents = {
    INGENICO: ingenicoAddCreditCard,
    SIXCARDS: sixcardsAddCreditCard,
    MONERIS: monerisAddCreditCard,
    PAGSEGURO: pagseguroAddCreditCard,
    NUVEI: nuveiAddCreditCard,
}

export const AddCreditCard = addCreditCardComponents[window.PAYMENT_SERVICE_PROVIDER]

export * as constants from './constants'
export * as actions from './actions'
export { reducer } from './reducers'
export { rootSaga } from './sagas'
export { creditCardsSelector } from './selectors'
